<div>
    <mat-form-field class="custom-table-filter">
        <mat-label><mat-icon>filter_list</mat-icon>Filter by keyword e.g. Vendor Name, Vendor No.</mat-label>
        <input matInput (keyup)="applyFilter($event)" #input>
    </mat-form-field>

    <div class="custom-table-wrapper--inner" [ngClass]="{'custom-table-wrapper--scroll-within': isScrollWithinTable}">
        <table class="mat-elevation-z3 table-content" mat-table multiTemplateDataRows #vendorTableSort="matSort" matSort
            [dataSource]="vendorDataSource">
            <ng-container matColumnDef="{{ column }}" *ngFor="let column of vendorDisplayColumns">
                <div *ngIf="column === 'select'">
                    <ng-container *ngIf="selectionMode === SelectVendorTableSelectionMode.MULTIPLE">
                        <th mat-header-cell *matHeaderCellDef>
                            <mat-checkbox tabindex="0" (click)="$event.stopPropagation()"
                                (keypress)="$event.stopPropagation()" (change)="$event ? toggleAllVendorsRows() : null"
                                [checked]="hasSelectedVendor() && isAllVendorsSelected()"
                                [indeterminate]="hasSelectedVendor() && !isAllVendorsSelected()">
                            </mat-checkbox>
                        </th>
                        <td mat-cell *matCellDef="let row">
                            <mat-checkbox tabindex="0" (click)="$event.stopPropagation()"
                                (keypress)="$event.stopPropagation()" (change)="$event ? toggleVendorRow(row) : null"
                                [checked]="isVendorSelected(row)" [disabled]="row.isDisabled">
                            </mat-checkbox>
                        </td>
                    </ng-container>
                    <ng-container *ngIf="selectionMode === SelectVendorTableSelectionMode.SINGLE">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let row">
                            <mat-radio-group [ngModel]="selectedVendorNumbers[0]" (change)="$event ? onSelectSingleVendorRow(row) : null" [disabled]="row.isDisabled">
                                <mat-radio-button [value]="row.vendorNumber">
                                </mat-radio-button>
                            </mat-radio-group>
                        </td>
                    </ng-container>
                </div>

                <div *ngIf="column === 'vendorName'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Vendor Name</th>
                </div>
                <div *ngIf="column === 'contactPerson'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Contact Person</th>
                </div>
                <div *ngIf="column === 'vendorNumber'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Vendor No.</th>
                </div>
                <div *ngIf="column === 'country'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Country</th>
                </div>
                <div *ngIf="column === 'email'">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
                </div>
                <div *ngIf="column === 'action'">
                    <th mat-header-cell *matHeaderCellDef
                        [ngClass]="{'is-hidden': !actionsType || actionsType.length === 0}"
                        class="table-cell--freeze-right">Action</th>
                </div>

                <div *ngIf="column !== 'select' && column !== 'action'">
                    <td mat-cell *matCellDef="let element">{{ element[column] }}</td>
                </div>

                <div *ngIf="column === 'action'">
                    <td mat-cell *matCellDef="let element"
                        [ngClass]="{'is-hidden': !actionsType || actionsType.length === 0}"
                        class="table-cell--freeze-right custom-table-icon-buttons">
                        <button (click)="onRowEditClick(element)"
                            *ngIf="actionsType?.includes(SelectVendorTableAction.EDIT)"
                            type="button"><mat-icon>edit</mat-icon></button>
                        <button (click)="onRowDeleteClick(element)"
                            *ngIf="actionsType?.includes(SelectVendorTableAction.DELETE)"
                            type="button"><mat-icon>remove_circle_outline</mat-icon></button>
                    </td>
                </div>

            </ng-container>
            <tr mat-header-row *matHeaderRowDef="vendorDisplayColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: vendorDisplayColumns;"
                [ngClass]="{ 'custom-table-row--disabled': row.isDisabled }">
            </tr>
            <!-- Row shown when there is no matching data -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="100%" *ngIf="vendorDataSource.data.length > 0">No data matching the filter
                    "{{input.value}}"</td>
            </tr>
        </table>
    </div>
    <mat-paginator #vendorPaginator [pageSize]="defaultPageSize" (page)="onPaginatorPage($event)"
        [pageSizeOptions]="pageSizeOptions" showFirstLastButtons class="custom-table-paginator"></mat-paginator>

</div>